var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.233 2.25c-3.848 0-6.983 3.135-6.983 6.983s3.135 6.982 6.983 6.982 6.982-3.135 6.982-6.982S13.08 2.25 9.233 2.25m0 12.698a5.723 5.723 0 0 1-5.716-5.716 5.723 5.723 0 0 1 5.716-5.714 5.723 5.723 0 0 1 5.714 5.715 5.723 5.723 0 0 1-5.714 5.714"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.232 5.213a.85.85 0 0 0-.847.847c0 .465.382.848.847.848a.85.85 0 0 0 .848-.848.85.85 0 0 0-.848-.847M9.232 8.175a.637.637 0 0 0-.637.637v3.81a.637.637 0 1 0 1.275 0v-3.81a.637.637 0 0 0-.638-.637"
  })));
};
export default SvgInfo;